module.exports = __webpack_public_path__ + "static/registr-5.e35de765.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/registr/registr-5.svg
// module id = 1098
// module chunks = 115425316864083